const translations = {
  tripTypeNotAvailable: {
    _: 'This trip type is not available for :provider_name',
    'zh-hk': ':provider_name 不提供此保障類型',
  },
  noProducts: {
    _: 'No products available',
    'zh-hk': '暫無可用產品',
  },
  dismiss: {
    _: 'Dismiss',
    'zh-hk': '關閉',
  },
  searchError: {
    _: 'We couldn’t load the results. Please refresh the page to try again.',
    'zh-hk': '無法載入結果，請重新整理後再試。',
  },
};

export default translations;
